import { NodeUtils, EditorUtils } from '@ssml-editor/vue';
import { SAY_AS_TYPE } from './constant.js';

const sayAsPlugin = (editor) => {
  const { isInline, isVoid, insertNode } = editor;
  const newEditor = editor;
  newEditor.isInline = (element) => {
    const type = NodeUtils.getNodeType(element);
    if (type === SAY_AS_TYPE) return true;
    return isInline(element);
  };
  newEditor.isVoid = (element) => {
    const type = NodeUtils.getNodeType(element);
    if (type === SAY_AS_TYPE) return false;
    return isVoid(element);
  };
  newEditor.insertNode = (node) => {
    const type = NodeUtils.getNodeType(node);
    if (type === SAY_AS_TYPE && newEditor.selection) {
      EditorUtils.insertSpace(newEditor, newEditor.selection);
    }
    insertNode(node);
  };
  return newEditor;
};

export { sayAsPlugin };
//# sourceMappingURL=plugin.js.map
